<template>
  <div class="container">
    <div class="title">进度查询</div>
    <el-form class="form-inline">
      <!-- 球杆编号 -->
      <el-form-item label="球杆编号：" prop="number">
        <el-input
            v-model="formData.number"
            placeholder="请选择球杆编号"
            @keydown.prevent
            @click.native="openSelectDialog()"
            readonly
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="step-banner">
      <!--   动态拼接内容显示    -->
      <ul class="rate">

      </ul>
    </div>
    <div class="btn-group">
      <el-button type="primary" @click="getProgress">进度查询</el-button>
    </div>
    <div class="btn-group-back">
      <el-button type="default" @click="goHome">返回首页</el-button>
    </div>
    <el-footer class="s-footer">
      <p>JING-DIAN BILLIARD CLUB AFTER SALES</p>
    </el-footer>

    <!-- 调用提示语弹框组件 -->
    <MessageDialog
        v-if="showDialog"
        title="提示"
        :content="messageContent"
        confirmText="我知道了"
        :showCancel="false"
        @confirm="showDialog = false"
        @close="showDialog = false"
        closeOnMask
    />

    <!-- 引入自定义select组件 -->
    <SelectDialog
        :visible="selectDialogVisible"
        :options="selectOptions"
        :active-value="formData.number"
        @select="handleSelect"
        @close="selectDialogVisible = false"
    />
  </div>
</template>

<script>

import {productByUser, progress} from "@/api/sales";
import MessageDialog from "@/views/business/utils/messageDialog.vue";
import SelectDialog from "@/views/business/utils/selectDialog.vue";

export default {

  components: {
    SelectDialog,
    //消息提示组件 可以是纯文字 也可以是html格式
    MessageDialog: MessageDialog
  },
  data() {
    return {
      // 表单数据（双向绑定）
      formData: {
        number: ''
      },
      //提示信息提示弹框组件是否显示
      showDialog: false,
      //提示信息内容
      messageContent:'',

      //select弹框组件
      selectDialogVisible: false,
      selectOptions: [],
    }
  },

  created() {

  },
  methods: {

    //获取当前登录人名下注册登记的球杆
    openSelectDialog(){
      productByUser().then(res => {
        if (res.code === 200) {
          this.selectOptions = res.data;
          this.selectDialogVisible = true; // 打开弹框
        } else {
          this.showDialog = true;
          this.messageContent = res.returnMsg;
        }
      })
    },

    //获取当前登录人名下注册登记的球杆
    handleSelect(item) {
      this.formData.number = item.value; // 赋值到对应行
      this.selectDialogVisible = false; // 关闭弹框
      this.selectOptions = [];
    },
    //查询进度
    getProgress(){
      if(this.formData.number === ''){
        this.showDialog = true;
        let  msgStr = `请选择球杆编号`;
        this.messageContent = msgStr;
        return false;
      }
      //球杆编号
      let keyWord = this.formData.number;
      progress(keyWord).then(res => {

          if(res.code === 200){

            const data = res.data;
            console.log(124444,data)
            //先处理下动态返回的html标签内容
            const targetUl = document.querySelector('.rate');
            //先清空标签内的数据
            targetUl.innerHTML = '';

            if (data.code == 0) {
              //提示信息提示弹框组件是否显示
              this.showDialog = true;
              //提示信息内容
              this.messageContent = "您所输入的编号不存在，请重新输入";
              return false;
            } else if(data.code == 2){
              //未登记的
              // var keyword = data.keyword;
              // var urlType = data.urlType;
              //提示信息提示弹框组件是否显示
              this.showDialog = true;
              //提示信息内容
              this.messageContent = data.returnMsg;
              return false;
            } else if(data.code == 3){
              //已登记未申请售后的
              // var keyword = data.keyword;
              // var urlType = data.urlType;
              //提示信息提示弹框组件是否显示
              this.showDialog = true;
              //提示信息内容
              this.messageContent = data.returnMsg;
              return false;
            } else if(data.code == 4){
              //提示信息提示弹框组件是否显示
              this.showDialog = true;
              //提示信息内容
              this.messageContent = data.returnMsg;
              return false;
            }else {
              //有售后信息的
              if (!targetUl) return;

              // 遍历数据拼接HTML
              const htmlStr = data.map(item => {
                return  '<li>' +
                    '<span>'+item.send_time.substring(0, 10)+'</span>' +
                    '<p>'+item.code+'</p>' +
                    '</li>';
              }).join('');
              // 插入到ul中（追加）
              targetUl.insertAdjacentHTML('beforeend', htmlStr);
            }


          }
      });
    },
    // 返回首页
    goHome() {
      // 实际项目可替换为Vue Router跳转：this.$router.push('/')
      this.$router.replace('/sales_home');
    }
  }
}
</script>

<style lang="scss">
.container{
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #efefef;
  @media screen and (max-width: 768px) {

    /* ----------------------顶部标题------------------------------ */
    .title {
      text-align: center;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      background: #f6c27a;
      font-weight: bold;
    }

    /* ----------------------中部图片、进度信息等------------------------------ */

    .step-banner {
      min-height: 360px;
      .rate{
        min-height: 5rem;
      }
      .rate li{
        position: relative;
        padding: 20px;
        padding-left: 126px;
        background: #fff;

      }
      .rate li::before{
        position: absolute;
        content: "";
        top: 0;
        left: 100px;
        height: 100%;
        border-left: 3px solid #ddd;
      }
      .rate li::after{
        position: absolute;
        content: "";
        top: 50%;
        left: 94px;
        width: 10px;
        height: 10px;
        margin-top: -7px;
        background: #fff;
        border: 2px solid #f6c279;
        border-radius: 50%;
      }
      .rate li span{
        position: absolute;
        left: 15px;
        top: 50%;
        width: 70px;
        margin-top: -20px;
        font-size: 13px;
        color: #666;
        line-height: 20px;
      }
      .rate li p{
        position: relative;
        padding: 10px;
        line-height: 24px;
        font-size:14px;
        color: #fff;
        background: #f6c279;
      }
      .rate li p::before{
        position: absolute;
        content: "";
        left: -20px;
        top: 50%;
        margin-top: -6px;
        border: 6px solid transparent;
        border-left-width: 10px;
        border-right-width: 10px;
        border-right-color: #f6c279;
      }
    }

    /* --------------------表单文本框等-------------------------------- */

    .form-inline{
      padding: 10px 0;
    }

    .el-form-item{
      background: #FFFFFF;
      height: 50px;
      padding: 0 10px;
    }
    /* 1. 修改Label样式：字体大小、宽度、对齐方式 */
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important; /* Label字体大小（默认14px） */
      text-align: left !important;
      line-height: 50px;
    }
    .el-form-item__content{
      line-height: 50px;
      padding-left: 90px;
    }

    /* 2. 修改输入框/下拉框/日期选择器 样式 */
    /* 统一控件高度和字体大小 */
    .el-input__inner,
    .el-select-dropdown__item,
    .el-date-picker__header,
    .el-date-picker__cell {
      font-size: 16px !important;  /* 控件内文本大小（默认14px） */
      height: 50px !important;     /* 控件高度（默认36px） */
      line-height: 50px !important;/* 行高与高度一致，垂直居中 */
      border: none;
    }

    /* --------------------------底部按钮-------------------------- */
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 30px;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      height: 50px;
      line-height: 50px;
      margin: 20px 0 30px 0;
    }

    .el-button--primary{
      font-size: 20px;
      color: #0f0f0f;
      background: #f6c27a;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    .el-button--default{
      font-size: 20px;
      color: #0f0f0f;
      background: #dcdcdc;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    /* -----------------------底部页脚----------------------------- */
    .s-footer{
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center; /* 水平居中（主轴对齐） */
      align-items: center;     /* 垂直居中（交叉轴对齐） */
      p{
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }

  }

  // ===================== 平板适配（768px ≤ 宽度 < 1200px） =====================
  @media screen and (min-width: 768px) and (max-width: 1199px) {
    max-width: 900px; // 平板最大宽度
    margin: 0 auto; // 居中
    padding: 0 20px;
    /* ----------------------顶部标题------------------------------ */
    .title {
      text-align: center;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      background: #f6c27a;
      font-weight: bold;
    }

    /* ----------------------中部图片、进度信息等------------------------------ */

    .step-banner {
      min-height: 400px;
      .rate{
        min-height: 5rem;
      }
      .rate li{
        position: relative;
        padding: 20px;
        padding-left: 126px;
        background: #fff;

      }
      .rate li::before{
        position: absolute;
        content: "";
        top: 0;
        left: 100px;
        height: 100%;
        border-left: 3px solid #ddd;
      }
      .rate li::after{
        position: absolute;
        content: "";
        top: 50%;
        left: 94px;
        width: 10px;
        height: 10px;
        margin-top: -7px;
        background: #fff;
        border: 2px solid #f6c279;
        border-radius: 50%;
      }
      .rate li span{
        position: absolute;
        left: 15px;
        top: 50%;
        width: 70px;
        margin-top: -20px;
        font-size: 13px;
        color: #666;
        line-height: 20px;
      }
      .rate li p{
        position: relative;
        padding: 10px;
        line-height: 24px;
        font-size:14px;
        color: #fff;
        background: #f6c279;
      }
      .rate li p::before{
        position: absolute;
        content: "";
        left: -20px;
        top: 50%;
        margin-top: -6px;
        border: 6px solid transparent;
        border-left-width: 10px;
        border-right-width: 10px;
        border-right-color: #f6c279;
      }
    }

    /* --------------------表单文本框等-------------------------------- */

    .form-inline{
      padding: 10px 0;
    }

    .el-form-item{
      background: #FFFFFF;
      height: 50px;
      padding: 0 10px;
    }
    /* 1. 修改Label样式：字体大小、宽度、对齐方式 */
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important; /* Label字体大小（默认14px） */
      text-align: left !important;
      line-height: 50px;
    }
    .el-form-item__content{
      line-height: 50px;
      padding-left: 90px;
    }

    /* 2. 修改输入框/下拉框/日期选择器 样式 */
    /* 统一控件高度和字体大小 */
    .el-input__inner,
    .el-select-dropdown__item,
    .el-date-picker__header,
    .el-date-picker__cell {
      font-size: 16px !important;  /* 控件内文本大小（默认14px） */
      height: 50px !important;     /* 控件高度（默认36px） */
      line-height: 50px !important;/* 行高与高度一致，垂直居中 */
      border: none;
    }

    /* --------------------------底部按钮-------------------------- */
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 30px;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      height: 50px;
      line-height: 50px;
      margin: 20px 0 30px 0;
    }

    .el-button--primary{
      font-size: 20px;
      color: #0f0f0f;
      background: #f6c27a;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    .el-button--default{
      font-size: 20px;
      color: #0f0f0f;
      background: #dcdcdc;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    /* -----------------------底部页脚----------------------------- */
    .s-footer{
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center; /* 水平居中（主轴对齐） */
      align-items: center;     /* 垂直居中（交叉轴对齐） */
      p{
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }

  }

  // ===================== PC端适配（≥1200px） =====================
  @media screen and (min-width: 1200px) {
    max-width: 1200px; // PC端最大宽度
    margin: 0 auto; // 居中
    padding: 0 20px;
    /* ----------------------顶部标题------------------------------ */
    .title {
      text-align: center;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      background: #f6c27a;
      font-weight: bold;
    }

    /* ----------------------中部图片、进度信息等------------------------------ */

    .step-banner {
      min-height: 450px;
      .rate{
        min-height: 5rem;
      }
      .rate li{
        position: relative;
        padding: 20px;
        padding-left: 126px;
        background: #fff;

      }
      .rate li::before{
        position: absolute;
        content: "";
        top: 0;
        left: 100px;
        height: 100%;
        border-left: 3px solid #ddd;
      }
      .rate li::after{
        position: absolute;
        content: "";
        top: 50%;
        left: 94px;
        width: 10px;
        height: 10px;
        margin-top: -7px;
        background: #fff;
        border: 2px solid #f6c279;
        border-radius: 50%;
      }
      .rate li span{
        position: absolute;
        left: 15px;
        top: 50%;
        width: 70px;
        margin-top: -20px;
        font-size: 13px;
        color: #666;
        line-height: 20px;
      }
      .rate li p{
        position: relative;
        padding: 10px;
        line-height: 24px;
        font-size:14px;
        color: #fff;
        background: #f6c279;
      }
      .rate li p::before{
        position: absolute;
        content: "";
        left: -20px;
        top: 50%;
        margin-top: -6px;
        border: 6px solid transparent;
        border-left-width: 10px;
        border-right-width: 10px;
        border-right-color: #f6c279;
      }
    }

    /* --------------------表单文本框等-------------------------------- */

    .form-inline{
      padding: 10px 0;
    }

    .el-form-item{
      background: #FFFFFF;
      height: 50px;
      padding: 0 10px;
    }
    /* 1. 修改Label样式：字体大小、宽度、对齐方式 */
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important; /* Label字体大小（默认14px） */
      text-align: left !important;
      line-height: 50px;
    }
    .el-form-item__content{
      line-height: 50px;
      padding-left: 100px;
    }

    /* 2. 修改输入框/下拉框/日期选择器 样式 */
    /* 统一控件高度和字体大小 */
    .el-input__inner,
    .el-select-dropdown__item,
    .el-date-picker__header,
    .el-date-picker__cell {
      font-size: 16px !important;  /* 控件内文本大小（默认14px） */
      height: 50px !important;     /* 控件高度（默认36px） */
      line-height: 50px !important;/* 行高与高度一致，垂直居中 */
      border: none;
    }

    /* --------------------------底部按钮-------------------------- */
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 30px;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      height: 50px;
      line-height: 50px;
      margin: 20px 0 30px 0;
    }

    .el-button--primary{
      font-size: 20px;
      color: #0f0f0f;
      background: #f6c27a;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    .el-button--default{
      font-size: 20px;
      color: #0f0f0f;
      background: #dcdcdc;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    /* -----------------------底部页脚----------------------------- */
    .s-footer{
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center; /* 水平居中（主轴对齐） */
      align-items: center;     /* 垂直居中（交叉轴对齐） */
      p{
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }

  }

}
</style>